import { request } from './request'
const baseUrl = process.env.VUE_APP_BASEURL_USER
// 营销帐号列表查询接口
export const getAdsAccountList = (params) => {
  return request({
    method: 'get',
    url: '/ocean/api/v1/ads/account/list',
    params
  })
}
// 营销帐号状态更新接口
export const updateAccountAdsStatus = (data) => {
  return request({
    method: 'put',
    url: '/ocean/api/v1/ads/account/updateStatus',
    data
  })
}
// 营销帐号token信息查询接口
export const getTokenAdsList = () => {
  return request({
    method: 'get',
    url: '/ocean/api/v1/ads/account/token/list',
  })
}
// 营销帐号新增编辑接口
export const accountSaveOrUpdate = (data) => {
  return request({
    method: 'post',
    url: '/ocean/api/v1/ads/account/saveOrUpdate',
    data
  })
}
// 营销帐号token信息新增编辑接口
export const accountSaveToken = (data) => {
  return request({
    method: 'post',
    url: '/ocean/api/v1/ads/account/token/saveOrUpdate',
    data
  })
}
// 优化师列表查询接口
export const accountOptimizingList = (params) => {
  return request({
    method: 'get',
    url: '/ocean/api/v1/ads/account/optimizing/list',
    params
  })
}
// 增编辑优化师
export const saveOptimizingList = (data) => {
  return request({
    method: 'post',
    url: '/ocean/api/v1/ads/account/optimizing/saveOrUpdate',
    data
  })
}
// 增编辑优化师
export const saveBindCampaign = (data) => {
  return request({
    method: 'post',
    url: '/ocean/api/v1/ads/account/bindCampaign',
    data
  })
}
// 谷歌账号查询
export const getGoogleList = (params) => {
  return request({
    method: 'get',
    url: '/ocean/api/v1/ads/google/customer/page',
    params
  })
}
// 谷歌经理账号查询
export const getGoogleManagerList = (params) => {
  return request({
    method: 'get',
    url: '/ocean/api/v1/ads/google/account/list',
    params
  })
}
// 谷歌账号新增/编辑
export const setGoogleAccount = (data) => {
  return request({
    method: 'post',
    url: '/ocean/api/v1/ads/google/customer/saveOrUpdate',
    data
  })
}
// 谷歌经理账号新增/编辑
export const setGoogleManagerAccount = (data) => {
  return request({
    method: 'post',
    url: '/ocean/api/v1/ads/google/account/saveOrUpdate',
    data
  })
}
// 谷歌账号启用/禁用
export const setGoogleAccountStatus = (data) => {
  return request({
    method: 'put',
    url: '/ocean/api/v1/ads/google/customer/setStatus',
    data
  })
}

// 优化师-查询优化师列表
export const getTeamCamlist = (params) => {
  return request({
    method: 'get',
    url: `${baseUrl}/api/v1/user/ocean/team/listTeamUsers`,
    params
  })
}

// 删除优化师
export const deleteOptimizing = (data) => {
  return request({
    method: 'post',
    url: '/ocean/api/v1/ads/account/optimizing/delete',
    data
  })
}

// 删除时下拉列表
export const deleteOptimizingList = (params) => {
  return request({
    method: 'get',
    url: '/ocean/api/v1/ads/account/optimizing/listTeacher',
    params
  })
}

// Google-回调方法
export const getGoogleCallback = (params) => {
  return request({
    method: 'get',
    url: '/ocean/api/v1/ads/google/callback',
    params
  })
}

// google经理账号授权的方法
export const accountEmpower = (id) => {
  return request({
    method: 'put',
    url: `/ocean/api/v1/ads/google/account/empower/${id}`,
  })
}
